export default __webpack_public_path__ + "static/media/background-2x.e7c669d3.jpg";